import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';

import {
    makeStyles,
    Box,
    Grid,
    Button,
    Typography,
} from "@material-ui/core";



const useStylesAll = makeStyles(theme => ({
    coupon: {
        minWidth: "167px",
        width: "90%",
        backgroundColor: "#D4A6A5",
        color: "#FFFFFF",
        padding: "15px 0px",
        textAlign: "center",
        position: "relative",
        [theme.breakpoints.up('sm')]: {
          width: "191px",
          padding: "30px 23px",
        },
        '& > $title': {
          fontWeight: "700",
          color: "#FFFFFF",
          fontSize: "18px",
          lineHeight: "27px",
          [theme.breakpoints.up('sm')]: {
            fontSize: "28px",
            lineHeight: "42px"
          },
        },
        '& > $date': {
          color: "#FFFFFF",
          fontSize: "12px",
          lineHeight: "18px",
          [theme.breakpoints.up('sm')]: {
            fontSize: "14px",
            lineHeight: "21px",
          },
        },
        '& > $line': {
          minWidth: "167px",
          width: "100%",
          position: "absolute",
          left: 0,
          marginTop: "8px",
          [theme.breakpoints.up('sm')]: {
            width: "237px",
            marginTop: 0,
          },
        },
        '& > $btn': {
          backgroundColor: "#FFFFFF",
          color: "#D4A6A5",
          padding: "5px 33px",
          whiteSpace: "nowrap",
          marginTop: "40px",
          fontWeight: "400",
          [theme.breakpoints.up('sm')]: {
            padding: "5px 45px",
            marginTop: "45px",
          },
        },
        '&.expired': {
          backgroundColor: "#CCCCCC",
          '& > $btn': {
            color: "#CCCCCC",
          },
        },
      },
      title: {},
      date: {},
      line: {},
      btn: {},
}));

function RegisterProgressBar(props) {
    const {amount, validUntil, expired } = props;
    const classes = useStylesAll();
    const { t, i18n } = useTranslation();
    const history = useHistory();

    function toCoupon() {
      history.push("/"+i18n.language+"/profile/coupon");
    }

    return (
        <Grid item xs={6} md={4}>
          <Box className={expired ? `${classes.coupon} expired` : `${classes.coupon}`}>
            <Typography className={classes.title}>${amount} {t('coupon')}</Typography>
            <Typography className={classes.date}>{t('Valid till')} {validUntil}</Typography>
            <img src="/images/coupon_line.png" className={classes.line} />
            <Button type="button" className={classes.btn} onClick={() => {toCoupon()}}>
              {expired ? t('Expired') : t('View Details') }
            </Button>
          </Box>
        </Grid>
    );
}

export default RegisterProgressBar;
